<div class="dataset-selection-container margin-top-2">
  <div class="header-section">
    <button
      nbButton
      ghost
      status="primary"
      size="small"
      (click)="goBack()"
      class="back-button"
    >
      <nb-icon icon="arrow-back-outline"></nb-icon>
      Back to Studies
    </button>
    <h2 class="page-title">GWAS 1-6 Study Datasets</h2>
    <p class="page-subtitle">Select a dataset to explore (GRCh38)</p>
  </div>

  <ngx-spinner
    color="#D73647"
    bdColor="#00000050"
    [fullScreen]="false"
    size="medium"
  >
    <div>Loading datasets...</div>
  </ngx-spinner>

  <div *ngIf="datasets.length > 0" class="datasets-grid">
    <div
      *ngFor="let dataset of datasets; let i = index"
      class="dataset-card"
      (click)="selectDataset(dataset.name)"
    >
      <div class="card-header">
        <div class="header-left">
          <div class="dataset-number">{{ i + 1 }}</div>
          <h3 class="dataset-name">
            {{ dataset.display_name || dataset.name }}
          </h3>
        </div>
        <div class="dataset-arrow">
          <nb-icon icon="arrow-forward-outline"></nb-icon>
        </div>
      </div>
      <div class="card-content">
        <p class="dataset-description" *ngIf="dataset.description">
          {{ dataset.description }}
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="error-section">
    <div class="error-message">
      <h3>Unable to load datasets</h3>
      <p>{{ error.status }}: {{ error.message }}</p>
      <p class="redirect-notice">Redirecting to homepage...</p>
    </div>
  </div>
</div>
